/** Written courses awaiting recordings. Keep their A1 pages local until promotion. */
export const DEVELOPMENT_ONLY_MAIN_COURSES = Object.freeze([
  'bg', 'el', 'ga', 'pl', 'sk', 'sq', 'ar', 'zh', 'ka', 'ja',
  'ne', 'fa', 'ru', 'sw', 'vi',
]);
const developmentOnly = new Set(DEVELOPMENT_ONLY_MAIN_COURSES);

/** Guard direct requests and static generation as well as navigation. */
export function mainCourseIsAvailable(target, env = { NODE_ENV: process.env.NODE_ENV }) {
  const code = String(target || '').trim().toLowerCase();
  return env.NODE_ENV !== 'production' || !developmentOnly.has(code);
}
